/* Filtration Station cart: drawer, AJAX add-to-cart, quantity changes. */
(() => {
  if (window.FsCart) return;
  const SECTION = 'fs-cart-drawer';
  const root = () => document.getElementById('FsCartDrawer');
  let lastFocus = null;

  const setCount = (n) => {
    document.querySelectorAll('.fs-hdr__cart').forEach(a => {
      let b = a.querySelector('.fs-hdr__count');
      const vh = a.querySelector('.fs-vh');
      if (vh) vh.textContent = `Cart, ${n} ${n === 1 ? 'item' : 'items'}`;
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'fs-hdr__count'; b.setAttribute('aria-hidden', 'true'); a.appendChild(b); }
        b.textContent = Math.min(n, 99);
      } else if (b) b.remove();
    });
  };

  const swap = (html) => {
    const d = root(); if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('FsCartDrawer'); if (!fresh) return;
    d.querySelector('.fs-cd__panel').innerHTML = fresh.querySelector('.fs-cd__panel').innerHTML;
    const c = d.querySelector('[data-fs-cart-count]');
    if (c) setCount(parseInt(c.dataset.fsCartCount, 10) || 0);
  };

  const open = () => {
    const d = root(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.documentElement.classList.add('fs-lock');
    d.querySelector('.fs-cd__panel').focus();
    return true;
  };
  const close = () => {
    const d = root(); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('fs-lock');
    setTimeout(() => { d.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const refresh = () => fetch(`${window.location.pathname}?sections=${SECTION}`)
    .then(r => r.json()).then(j => swap(j[SECTION]));

  const onCartPage = () => document.body.classList.contains('fs-tpl-cart');

  const change = (line, quantity, busyEl) => {
    if (busyEl) busyEl.closest('.fs-line')?.classList.add('is-busy');
    return fetch(window.Shopify?.routes?.root ? `${Shopify.routes.root}cart/change.js` : '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: [SECTION], sections_url: window.location.pathname })
    }).then(r => r.json()).then(j => {
      if (onCartPage()) { window.location.reload(); return; }
      if (j.sections) swap(j.sections[SECTION]); else refresh();
    });
  };

  const add = (form) => {
    const btn = form.querySelector('[type=submit]');
    const err = form.querySelector('[data-fs-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn && btn.setAttribute('aria-busy', 'true');
    btn && (btn.disabled = true);
    const fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok || j.status) {
          if (err) { err.textContent = j.description || j.message || 'Sorry, that could not be added. Please try again.'; err.hidden = false; }
          return;
        }
        if (j.sections) swap(j.sections[SECTION]); else return refresh().then(open);
        open();
      })
      .catch(() => form.submit())
      .finally(() => { btn && btn.removeAttribute('aria-busy'); btn && (btn.disabled = false); });
  };

  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('a.fs-hdr__cart');
    if (cartLink && !onCartPage() && root()) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-fs-close]')) { close(); return; }
    const q = e.target.closest('[data-fs-qty]');
    if (q) {
      const li = q.closest('.fs-line'); if (!li) return;
      e.preventDefault();
      change(parseInt(li.dataset.line, 10), parseInt(q.dataset.fsQty, 10), q);
    }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-fs-qty-input]'); if (!i) return;
    const li = i.closest('.fs-line');
    change(parseInt(li.dataset.line, 10), Math.max(0, parseInt(i.value, 10) || 0), i);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-fs-product-form]');
    if (!f || !root()) return;
    e.preventDefault(); add(f);
  });
  document.addEventListener('keydown', (e) => {
    const d = root(); if (!d || d.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...d.querySelectorAll('a[href],button:not([disabled]),input,select')].filter(x => x.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  window.FsCart = { open, close, refresh, add };
})();
